export const hexToRgb = (hex) => {
    if (hex.length === 3) {
        hex = '' + hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    
    return [
        parseInt(hex.substring(0, 2), 16),
        parseInt(hex.substring(2, 4), 16),
        parseInt(hex.substring(4, 6), 16),
    ];
};

export const hexToRgba = (hex, opacity = 100) => {
    if (!hex) return null;

    const rgbColor = hexToRgb(hex.replace('#', ''));

    return `rgba(${rgbColor[0]}, ${rgbColor[1]}, ${rgbColor[2]}, ${opacity}%)`;
};
